import React from 'react'
import CareerTrands from '../../../Components/Career-trends/career-trends'

const CareerTranding = () => {
  return (
    <div><CareerTrands/></div>
  )
}

export default CareerTranding